export default {
  path: '/',
  meta: {
    title: '租户管理'
  }
};
